'use strict';

angular.module('atex.dam').controller('DamRatingController', [ '$scope', function($scope) {
  
  $scope.ratingArray = [];
  if ($scope.currentRating===undefined) {
    $scope.currentRating = '0';
  }
  
  $scope.$watch(function() {
    return $scope.range;
  }, function(newValue, oldValue) {
    $scope.ratingArray.length = 0;
    var i = 0;
    for (i = 0; i < $scope.range; i++) {
      var obj = {
        id : (i+1).toString(),
        iconclass : (i+1 <= $scope.currentRating) ? $scope.ratingIcons[1] : $scope.ratingIcons[0],
        rate : 0
      };
      $scope.ratingArray.push(obj);
    }
  });
  
  $scope.$watch(function() {
    return $scope.currentRating;
  }, function(newValue, oldValue) {
    if (newValue===undefined) {
      newValue='0';
    } 
    $scope.select(newValue);
  });
  
  $scope.mouseover = function(rating, fromUI) {
    if ($scope.disabled && fromUI) {
      return;
    }
    var i = 0;
    for (i = 0; i < rating; i++) {
      $scope.ratingArray[i].iconclass = $scope.ratingIcons[1];
    }
    for (i = rating; i < $scope.range; i++) {
      if($scope.ratingArray[i]) {
        $scope.ratingArray[i].iconclass = $scope.ratingIcons[0];
      }
    }
  };
  
  $scope.select = function(rating, fromUI, $event) {
    if ($scope.disabled && fromUI) {
      return;
    }
    if (!$scope.resetIcon && fromUI && rating===$scope.currentRating) {
      // Reset rating
      $scope.mouseover(0);
      $scope.currentRating = '0';
    } else {
      $scope.mouseover(rating);
      $scope.currentRating = rating;
    }
    
    if (fromUI) {
      $scope.selectCallBack({rating: $scope.currentRating});
    }
    if ($event) {
      $event.stopPropagation();
    }
  };
  
  $scope.mouseleave = function() {
    $scope.mouseover($scope.currentRating);
  };
  
} ]);

angular.module('atex.dam').directive('damRating', function() {
  return {
    restrict : 'E',

    templateUrl : 'js/dam/widgets/dam-rating/dam-rating.html',

    replace : true,

    scope : {
      label : '@',
      range : '=',
      resetIcon : '@',
      currentRating : '=',
      ratingIcons : '=',
      selectCallBack : '&',
      disabled : '='
    },

    controller : 'DamRatingController',

    link : function(scope, element, attrs) {
      
    }
  };
});
